import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';
import React from 'react';

import { PageViewRestrictions } from './PageViewRestrictions.tsx';
import { SpaceRestrictionCheck } from './SpaceRestrictionCheck.tsx';

type RestrictionsCheckProps = {
	children: (result: {
		error: ApolloErrorInterop | undefined;
		hasDirectViewRestrictions: boolean | undefined;
		hasInheritedViewRestrictions: boolean | undefined;
		isSpaceRestricted: boolean | undefined;
	}) => JSX.Element | null;
	contentId: string;
	spaceKey: string;
};

export const RestrictionsCheck = ({
	children,
	spaceKey,
}: RestrictionsCheckProps): React.JSX.Element => (
	<SpaceRestrictionCheck asSuperAdmin={false} spaceKey={spaceKey}>
		{({ error: spaceRestrictionCheckError, isSpaceRestricted }) => (
			<PageViewRestrictions>
				{({
					error: pageViewRestrictionsError,
					hasDirectViewRestrictions,
					hasInheritedViewRestrictions,
				}) =>
					children({
						error: spaceRestrictionCheckError || pageViewRestrictionsError,
						hasDirectViewRestrictions,
						hasInheritedViewRestrictions,
						isSpaceRestricted,
					})
				}
			</PageViewRestrictions>
		)}
	</SpaceRestrictionCheck>
);
